<template>
    <div class="new-page-main">
        <!--搜索查询栏-->
        <dt-search-bar style="padding:20px 5px 5px;">
            <template slot="filterSlot">
                <data-filter
                        class="data-fil"
                        ref="dataFilterRef"
                        :timeData="timeData"
                        :schoolId="''"
                        :contentObject="contentObject"
                        :buttonColor="'#00CAAF'"
                        @filter-data="filterData"
                ></data-filter>
            </template>
            <template slot="buttonSlot">
                <div style="display: flex;float: right;">
                    <!--搜索框-->
                    <div class="big-data-search-input">
                        <input placeholder="支持学校名称关键字搜索" class="big-data-input-cla" v-model="listFilters.keyWord"
                               v-on:keyup.enter="handleSearch"/>
                        <div class="big-data-search-btn" v-on:click="handleSearch">
                            <div class="big-data-search-icon">
                                <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                     height="100%"/>
                            </div>
                        </div>
                    </div>
                    <!--导出按钮-->
                    <!--<div v-on:click="exportInfoToExcel" class="export-btn">列表导出</div>-->
                </div>
            </template>
        </dt-search-bar>
        <div style="margin-top: 50px;">
            <!--&lt;!&ndash;数据统计图&ndash;&gt;-->
            <!--<div class="data-statistics-img" ref="dataStatistics">-->
            <!--<ul>-->
            <!--<template v-for="(item,index) in dataSummaryMap">-->
            <!--<data-statis-summary-->
            <!--:num="item.value"-->
            <!--:text="item.key"-->
            <!--:remindText="item.remindText"-->
            <!--&gt;</data-statis-summary>-->
            <!--</template>-->
            <!--</ul>-->
            <!--</div>-->
            <!--表格-->
            <div class="new-table-main-wrap" ref="tableMainRef">
                <div class="table-main">
                    <!--作业列表-->
                    <Table :columns="schoolColumn" :data="schoolList"
                           :row-class-name="rowClassName" :loading="isLoading"></Table>
                    <div class="bottom-page">
                        <div class="laypage_main">
                            <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                                  v-if="pageParams.total && pageParams.pageCount>1" show-total></Page>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        findTotalSchoolByAgentId
    } from "../../../../service/bigDataApi.js";
    import {findUserInfo} from "../../../../service/api.js";
    import {mapGetters} from 'vuex'

    const DtSearchBar = () => import('../../../../components/DtSearchBar');
    const DataFilter = () => import('../../../../components/DataFilter');
    const DataStatisSummary = () => import('../../../../components/DataStatisSummary');
    export default {
        name: "new-data-list",
        components: {
            DtSearchBar,
            DataFilter,
            DataStatisSummary
        },
        computed: {
            ...mapGetters([
                'homeWorkReportPath'
            ]),
        },
        data() {
            return {
                //加载中
                isLoading: true,
                //数据概览集合
                dataSummaryMap: [],
                contentObject: {
                    //是否显示时间切换按钮
                    displayTimeFilter: true,
                    //是否显示学年下拉框
                    displayYearFilter: false,
                    //是否显示学段下拉框
                    displayPhaseFilter: true
                },
                schoolId: this.$route.params.schoolId == 0 ? '' : this.$route.params.schoolId,
                //列表参数
                listFilters: {
                    keyWord: this.$route.params.filtersName == '0' ? '' : this.$route.params.filtersName,
                    hwType: '-1',
                    isShareMicro: '0',
                    isShareResource: '0'
                },
                //日期集合
                timeData: [
                    {
                        key: 0,
                        value: '全部'
                    }, {
                        key: 1,
                        value: '近一周'
                    }, {
                        key: 2,
                        value: '近一月'
                    }, {
                        key: 4,
                        value: '近三月'
                    }
                ],
                filters: {},
                schoolList: [],//学校集合
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                },
                previewMode: false,
                previewVideoMode: false,
                videoSrc: "",
                tabsName: this.$route.params.tabsName,
                dataDetailStyle: {
                    height: '850px'
                },
                searchHeight: {},
                placeholder: '',
                //学校列
                schoolColumn: [
                    {
                        title: "所属学校",
                        key: "school_name",
                        width: 300,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击查看各校数据展板",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "#0199ff",
                                            fontSize: "14px",
                                        },
                                        on: {
                                            click: () => {
                                                this.lookSchoolDataBoard(params.row)
                                            }
                                        }
                                    },
                                    params.row.school_name
                                )
                            ]);
                        }
                    },
                    {
                        title: "所属学段",
                        key: "phase",
                        render: (h, params) => {
                            if (params.row.phase == '1') {
                                return h('span', '小学')
                            } else if (params.row.phase == '2') {
                                return h('span', '初中')
                            } else if (params.row.phase == '3') {
                                return h('span', '高中')
                            }
                        }
                    },
                    {
                        title: "使用班级数",
                        key: "use_class_num",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('use_class_num');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '使用班级数'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        }
                    },
                    {
                        title: "班级总数",
                        key: "class_num",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('class_num');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '班级总数'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        }
                    },
                    {
                        title: "使用教师数",
                        key: "use_tea_num",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('use_tea_num');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '使用教师数'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        }
                    },
                    {
                        title: "教师总数",
                        key: "tea_num",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('tea_num');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '教师总数'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        }
                    }, {
                        title: "使用学生数",
                        key: "use_stu_num",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('use_stu_num');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '使用学生数'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        }
                    },
                    {
                        title: "学生总数",
                        key: "stu_num",
                        renderHeader: (h, params) => {
                            return h("div",
                                {
                                    attrs: {
                                        class: "sort-col",
                                    },
                                    on: {
                                        click: () => {
                                            this.sortData('stu_num');
                                        }
                                    }
                                },
                                [
                                    h("span", {
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }, '学生总数'),
                                    h("img", {
                                        attrs: {
                                            class: "sort-fun",
                                            src: "/icon_change.png"
                                        },
                                        style: {
                                            cursor: "pointer"
                                        }
                                    }),
                                ]);
                        }
                    }
                ],
                orderList: [
                    {
                        sortType: 'use_class_num',
                        orderType: 'desc'
                    },
                    {
                        sortType: 'class_num',
                        orderType: 'desc'
                    },
                    {
                        sortType: 'use_tea_num',
                        orderType: 'desc'
                    },
                    {
                        sortType: 'tea_num',
                        orderType: 'desc'
                    },
                    {
                        sortType: 'use_stu_num',
                        orderType: 'desc'
                    },
                    {
                        sortType: 'stu_num',
                        orderType: 'desc'
                    }
                ],
                order: 'use_class_num desc'
            }
        },
        created() {
            this.syncAgentContext();
            this.setCurrentPathArr();
        },
        watch: {
            'listFilters.keyWord': {
                handler(newValue, oldValue) {
                    this.handleSearch();
                },
                deep: true
            }
        },
        methods: {
            syncAgentContext() {
                const { agentId, agentName } = this.$route.query;
                if (agentId) {
                    this.$store.commit("SET_AGENTID", agentId);
                }
                if (agentName) {
                    this.$store.commit("SET_AGENTName", agentName);
                }
            },
            /**
             * 设置面包屑
             */
            setCurrentPathArr() {
                let currentPathArr;
                currentPathArr = [
                    {
                        title: "首页",
                        path: "regiondataboard",
                        name: "regiondataboard",
                        query: {
                            agentId: this.$route.query.agentId || this.$store.getters.agentId,
                            agentName: this.$route.query.agentName || this.$store.getters.agentName
                        }
                    },
                    {
                        title: this.$store.getters.agentName,
                        path: "",
                        name: 'regiondatalist'
                    }
                ];
                this.$store.commit("setCurrentPath", currentPathArr);
            },
            /**
             * 导出产品信息
             */
            exportInfoToExcel() {
            },
            /**
             * 筛选数据
             */
            filterData(filters, searchHeight) {
                this.pageParams.page = 1;
                this.pageParams.total = 0;
                this.isLoading = true;
                this.filters = filters;
                this.searchHeight = searchHeight;
                this.findRegionSchoolList();
            },
            /**
             * 获取区域的学校列表
             */
            async findRegionSchoolList() {
                let _this = this;
                let params = {
                    agentId: _this.$route.query.agentId || _this.$store.getters.agentId,
                    phase: _this.filters.phase == 0 ? "" : _this.filters.phase,
                    provinceId: "",
                    cityId: "",
                    districtId: "",
                    type: _this.filters.timeSolt == 4 ? 3 : _this.filters.timeSolt == 0 ? '' : _this.filters.timeSolt,
                    pageno: _this.pageParams.page,
                    pagesize: _this.pageParams.limit,
                    keyword: _this.listFilters.keyWord,
                    order: _this.order
                };
                let resultData = await findTotalSchoolByAgentId(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                //隐藏加载中样式
                _this.isLoading = false;
                _this.schoolList = [];
                _this.pageParams.total = 0;
                if (Object.keys(resultData).length > 0) {
                    _this.schoolList = resultData.rows;
                    _this.pageParams.total = resultData.total_rows;
                    _this.pageParams.pageCount = resultData.page_count;
                    _this.$nextTick(() => {
                        _this.dataDetailStyle.height = _this.searchHeight + _this.$refs.tableMainRef.clientHeight + 50 + 'px';
                    })
                }
            },
            /**
             * 查看各校的数据展板
             */
            lookSchoolDataBoard(rows) {
                let routeData = this.$router.resolve({
                    name: rows.school_id=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                    params: {
                        schoolId: rows.school_id
                    },query:{
                        tokenId:this.$store.getters.token
                    }
                });
                window.open(routeData.href, "_blank");
            },
            /**
             * 翻页
             */
            handleCurrentChange(val) {
                this.pageParams.page = val;
                this.isLoading = true;
                this.findRegionSchoolList();
            },
            /**
             * 查询
             */
            handleSearch() {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.isLoading = true;
                this.findRegionSchoolList();
            },
            /**
             * 排序
             */
            sortData(sortType) {
                let data = [];
                data = this.orderList;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].sortType == sortType) {
                        data[i].orderType = data[i].orderType == 'desc' ? 'asc' : 'desc';
                        this.order = data[i].sortType + ' ' + data[i].orderType;
                    }
                }
                this.pageParams.page = 1;
                this.findRegionSchoolList();
            },
            /**
             * 表格斑马纹
             */
            rowClassName(row, index) {
                if (index % 2 == 0) {
                    return 'ivu-table-stripe-even';
                } else return 'ivu-table-stripe-odd';
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";

    .circle-data {
        background: url("../../../../assets/images/databoard/detailPage/green-circle.png") top no-repeat;
    }

    .panel-box {
        background-image: url("../../../../assets/images/databoard/modal-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%
    }

    .big-data-search-btn {
        background: #00CAAF !important;
        color: #fff;
        border-color: #00CAAF !important;
    }

    /*图片预览遮罩层*/
    .img-ml-box {
        position: fixed;
        top: 0px;
        height: 100%;
        left: 0px;
        right: 0px;
        bottom: 0px;
        width: 100%;
        z-index: 50;
        display: none;
    }

    /*遮罩层背景*/
    .img-ml-box .img-ml-bg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        background: #000;
        opacity: 0.8;
        z-index: 55;
    }

    /*关闭按钮*/
    .img-ml-box .img-ml-close {
        position: absolute;
        right: 15px;
        top: 10px;
        width: 32px;
        height: 32px;
        z-index: 999;
        opacity: 0.6;
        background: url('../../../../assets/images/databoard/close.png') center center no-repeat;
    }

    .img-ml-box .img-ml-close:hover {
        opacity: 1;
    }

    .audio-player-container {
        position: absolute;
        z-index: 70;
        top: 44%;
        left: 50%;
        width: 70%;
        max-width: 1200px;
        padding: 33px 80px 33px 156px;
        margin: 0 auto;
        display: block;
        background-color: #fff;
        border-radius: 5px;
        -webkit-transform: translate3d(-50%, -50%, 0);
        -moz-transform: translate3d(-50%, -50%, 0);
        -ms-transform: translate3d(-50%, -50%, 0);
        -o-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
        display: none;
    }

    .audio-player-container .audio-progress {
        width: 100%;
        height: 24px;
        background: rgba(239, 241, 250, 1);
        border: 1px solid rgba(232, 234, 244, 1);
        border-radius: 12px;
        overflow: hidden;
    }

    .audio-player-container .audio-progress .audio-progress-bar {
        height: 100%;
        background: rgba(62, 115, 246, 1);
        border-radius: 12px;
    }

    .audio-player-container .play-btn {
        position: absolute;
        top: 21px;
        left: 71px;
        width: 50px;
        height: 50px;
        background: url("../../../../assets/images/databoard/icon-audioplayer.png") no-repeat;
        cursor: pointer;
    }

    .audio-player-container .play-btn:active {
        opacity: .6;
    }

    .audio-player-container .play-btn.play {
        background-position: 1px 1px;
    }

    .audio-player-container .play-btn.pause {
        background-position: 1px -64px;
    }

    .data-fil {
        margin-left: 22px;
    }
</style>

<style lang="scss">
    .new-data-tab-area {
        .ivu-tabs-bar {
            border-bottom: 0;
            background: #f2f5f3;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container {
            height: 40px;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
            height: 40px;
            margin-right: 1px;
            padding: 9px 16px 4px;
        }

        .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
            height: 40px;
            color: #00caaf;
        }

        .ivu-tabs-nav .ivu-tabs-tab:hover {
            color: #00caaf;
        }

        .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
            border-color: #dcdee2 !important;
        }
    }

    .table-main {
        /*偶数行*/
        .ivu-table-stripe-even td {
            background-color: #fff !important;
        }

        /*奇数行*/
        .ivu-table-stripe-odd td {
            background-color: #fafbfd !important;
        }

        .ivu-table th {
            background-color: #f3f7f6;
            height: 50px !important;
            font-weight: bold;
        }
        .ivu-table td, .ivu-table th {
            border-bottom: 0;
        }
        .ivu-table:before {
            background-color: #efefef !important;
        }
        .ivu-table:after {
            background-color: #efefef !important;
        }
        .ivu-table-wrapper {
            border-top: 1px solid #efefef;
            border-left: 1px solid #efefef;
        }
    }
</style>
